// Calculator is free until the end of 2026 (UK time = GMT in winter)
const FREE_UNTIL = new Date('2027-01-01T00:00:00Z');

export const isFreePeriod = () => new Date() < FREE_UNTIL;